import React, { useContext } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { useTheme } from "@mui/material/styles";
import { ItemsPerPageSelectProps } from "../../Types/types";
import { ThemeContext } from "../../hooks/themeContext";

const ItemsPerPageSelect: React.FC<ItemsPerPageSelectProps> = ({
  itemsPerPage,
  handleItemsPerPageChange,
}) => {
  const theme = useTheme();

  const { isDark } = useContext(ThemeContext);

  return (
    <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
      <Select
        value={itemsPerPage}
        onChange={handleItemsPerPageChange}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
        sx={{
          ".MuiSelect-select": {
            padding: "8px",
            paddingRight: "32px",
            border: "none",
            "&:focus": {
              backgroundColor: "transparent",
            },
            color: isDark
              ? theme.palette.common.white
              : theme.palette.text.primary,
          },
          ".MuiSvgIcon-root": {
            color: isDark ? theme.palette.common.white : "rgba(0, 0, 0, 0.54)",
          },
        }}
      >
        <MenuItem value={10}>10</MenuItem>
        <MenuItem value={20}>20</MenuItem>
        <MenuItem value={30}>30</MenuItem>
      </Select>
    </FormControl>
  );
};

export default ItemsPerPageSelect;
